export const TemplateType = {
  TemplateOne: 'TemplateOne',
  TemplateTwo: 'TemplateTwo',
  TemplateThree: 'TemplateThree',
};
